module.exports = __webpack_public_path__ + "img/img_vacancy.c590e0b8.png";